import { PropTypes } from 'prop-types';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import FeedbackEditForm from '../components/FeedbackEditForm';
import Feedback from '../models';

const initialFormValues = {
  customerName: null,
  type: 0,
  comment: null,
  priority: 0,
  actionTaken: 0,
};

const UpsertFeedbackDialog = ({ title, isOpen, isNew, initialFeedback, onSubmit }) => {
  const dispatch = useDispatch();
  const formRef = useRef();

  const closeDialog = () => dispatch(hideDialog());

  const handleFormSubmit = async (formValues) => {
    const payload = isNew ? formValues : { ...formValues, id: initialFeedback.id };
    try {
      await onSubmit(payload).unwrap();
      dispatch(hideDialog());
    } catch (err) {
      toastr.error('Error', 'Failed to save feedback.');
    }
  };

  const onReady = () => {
    if (formRef.current?.submit) {
      formRef.current.submit();
    }
  };

  const formInitialValues = isNew ? initialFormValues : initialFeedback;

  return (
    <ModalDialog
      title={title}
      onReady={onReady}
      isOpen={isOpen}
      close={closeDialog}
      disabled={false}
    >
      <FeedbackEditForm
        ref={formRef}
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
      />
    </ModalDialog>
  );
};

UpsertFeedbackDialog.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isNew: PropTypes.bool,
  initialFeedback: PropTypes.instanceOf(Feedback),
  onSubmit: PropTypes.func.isRequired,
};

export default UpsertFeedbackDialog;
